module.exports = __webpack_public_path__ + "static/media/pocket_watch.cf77c9ec.svg";